/*
 * @Description: 
 * @Author: Lidya
 * @Date: 2022-12-08 12:26:00
 * @LastEditors: Lidya
 * @LastEditTime: 2022-12-30 11:00:45
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
 
Vue.use(VueI18n)
 
const DEFAULT_LANG = 'zh'
const LOCALE_KEY = 'localeLanguage'
 
const locales = {
  zh: require('./zh.js'),
  en: require('./en.js'),
  tc: require('./tc.js'),
  ja: require('./ja.js'),
  it: require('./it.js'),
  fr: require('./fr.js'),
  es: require('./es.js'),
  de: require('./de.js'),
  
}
 
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
})
 
 
export const setup = lang => {
  if (lang === undefined) {
    lang = window.localStorage.getItem(LOCALE_KEY)
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  window.localStorage.setItem(LOCALE_KEY, lang)
 
  Object.keys(locales).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)
 
  Vue.config.lang = lang
  i18n.locale = lang
}
 
setup("en")
window.$i18n = i18n;
export default i18n